import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { Link } from "react-router-dom";
import corporateclients from "assets/img/Untitled design(2).svg";
import InstaNewsSection from "./LandingPageSections/InstaNewsSection";
import AppNavbar from "components/Navbars/AppNavbar";
import FooterBlack from "components/Footers/FooterBlack";
import TeamDisplay from "views/TeamDisplay";
import Testimonials from "components/Testimonials";
import { getProducts } from "../service/products";
import HeaderWithCarousel from "components/Headers/HeaderWithCarousel";
import ScrollingFlags from "./LandingPageSections/Flag";
import QuizButton from "components/QuizButton/QuizButton"; // Import the Quiz Button component
import "../Styling/App.css";
import "../Styling/LandingPage.css";
import DiscountModal from "components/DiscountModal";
import { useAuth } from "contexts/authContext/authContext";
import { getUserById } from "services/user.service";
import {useLoader} from "contexts/loaderContext/loaderContext";

function LandingPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [teamLoading, setTeamLoading] = useState(true);
  const [newsLoading, setNewsLoading] = useState(true);
  const [media, setMedia] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userHasDiscount, setUserHasDiscount] = useState(true);
  // Function to toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const { showLoader, hideLoader } = useLoader();

  // const accessToken =
  //   "IGQWROcDIwR1BHeWJEcnRrQjFncDhmUkFWSGVHdkZAINnplMGY1c0t4d2kteGxsOVZANVWV0MFZANNlJpME5DaVFVNV9QcXktUUdScVNMY1hQMWNJRVpLRmJTcGVwZAzJkbV9yeTE2S2dhRXk2eXJ6OG1jdFlROUFKbkUZD";
  const accessToken =
    "IGAAH99oCC93JBZAE5pTnpMUkJsQlNndG9NQW1XaGdzaTVwTmxTMlNka2N6Qi1VZAm9qSm9RSVhzT3MyS0RMRkxJTWpsMWtHNXNYOXFwMjVKb2tQblVuWFRsSVBtRjY0MnJ5aVFIdEdiaTN4WURpOVdQeFpZANUZA1Y3lsbVRCcGstMAZDZD";

  useEffect(() => {
    document.body.classList.add("landing-page");
    window.scrollTo(0, 0);
    fetchProducts();
    fetchInstagramMedia();

    setTimeout(() => {
      setTeamLoading(false);
    }, 1500);

    return () => {
      document.body.classList.remove("landing-page");
    };
  }, []);
  useEffect(() => {
    const checkUserStatus = async () => {
      showLoader(); // Show loader while checking user status

      if (user) {
        console.log("User is logged in:", user);
        setIsLoggedIn(true);

        const response = await getUserById(user.uid);
        if (response.success && response.data) {
          const userData = response.data;
          setUserHasDiscount(userData.data.hasDiscount);
        }
      } else {
        setIsLoggedIn(false);
        setUserHasDiscount(false); // Reset discount status for logged-out users
      }

      hideLoader(); // Hide loader after checking user status
    };

    checkUserStatus();
  }, [user]);
  useEffect(() => {
    // Show the modal only if the user is not logged in or does not already have a discount
    if (!isLoggedIn || !userHasDiscount) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [isLoggedIn, userHasDiscount]);

  const fetchProducts = async () => {
    // showLoader();
    const response = await getProducts();
    if (
      response.success &&
      response.data != undefined &&
      response.data.length > 0
    ) {
      let data = [...response.data].sort((a, b) => a.p_order - b.p_order);
      setProducts([...data]);
      setProductsLoading(false);
      // hideLoader();
    }
  };

  const fetchInstagramMedia = async () => {
    try {
      const response = await fetch(
        `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${accessToken}`
      );
      const data = await response.json();
      setMedia(data.data);
      setNewsLoading(false);
    } catch (error) {
      console.error("Error fetching Instagram media:", error);
      setNewsLoading(false);
    }
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let monthIndex = new Date().getMonth();

  return (
    <>
      <AppNavbar />
      <HeaderWithCarousel />

      {/* Pop-up Modal for take quiz and get 10% discount */}
      {<DiscountModal isOpen={isModalOpen} toggle={toggleModal} />}
      <div className="wrapper">
        <div className="section text-center landing-section">
          <Container className="custom-container">
            <Row>
              <Col className="ml-auto mr-auto" md="8">
                <h2
                  className="title"
                  style={{
                    fontWeight: "bold",
                    marginTop: "60px",
                    fontSize: "clamp(18px, 5vw, 45px)",
                  }}
                >
                  WELCOME TO ELEVATE AFRICA ACADEMY
                </h2>
                <p
                  className="card-description"
                  style={{
                    fontWeight: "400",
                    fontSize: "clamp(1rem, 3vw, 18px)",
                  }}
                >
                  Welcome to the world of eloquence and expression! Our
                  comprehensive courses are designed to unlock your potential,
                  giving you the tools to captivate audiences and master the art
                  of communication. Whether you’re aspiring to become a public
                  speaking pro or a voice-over artist, our expert-led training
                  will guide you every step of the way. Elevate your voice,
                  empower your message, and embark on a journey to speaking
                  success with us. Start transforming your vocal presence today!
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Quiz Button Section - Add this right after the welcome section */}
        {/* <div
          className="section"
          style={{ backgroundColor: "#f5f6fa", padding: "30px 0" }}
        >
          <Container>
            <QuizButton />
          </Container>
        </div> */}

        {/* Experienced Team Section */}
        <div
          className="section text-center landing-section"
          style={{ paddingTop: "0px", paddingBottom: "10px" }}
        >
          <div
            className="section"
            style={{
              backgroundColor: "#f5f6fa",
              paddingBottom: "40px",
              paddingTop: "0px",
            }}
          >
            <h2
              className="title"
              style={{
                fontWeight: "bold",
                marginTop: "0px",
                paddingTop: "40px",
                fontSize: "clamp(18px, 5vw, 45px)",

                marginBottom: "40px",
              }}
            >
              EXPERIENCED TEAM
            </h2>

            {teamLoading ? (
              <div className="text-center">
                <Spinner color="info" />
              </div>
            ) : (
              <TeamDisplay />
            )}
          </div>

          {/* What to Expect Section */}
          <div className="section" style={{ paddingTop: "0px" }}>
            <Container>
              <Row>
                <Col className="ml-auto mr-auto text-center" md="8">
                  <h2
                    className="title"
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      marginTop: "40px",
                      marginBottom: "10px",
                      fontSize: "clamp(24px, 5vw, 36px)",
                    }}
                  >
                    WHAT TO EXPECT
                  </h2>
                </Col>
              </Row>

              {productsLoading ? (
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                products &&
                products.length > 0 &&
                products.map((product, index) => (
                  <Row
                    key={index}
                    style={{
                      backgroundColor: "8A95A5",
                      marginBottom: "0px",
                      marginTop: "20px",
                      borderRadius: "8px",
                    }}
                  >
                    {/* Mobile-only title */}
                    <Col xs="12" className="d-md-none">
                      <h3
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          textTransform: "uppercase",
                          fontSize: "clamp(18px, 4vw, 1.5em)",
                          marginBottom: "20px",
                          marginTop: "20px",
                          textAlign: "left",
                          paddingLeft: "15px",
                        }}
                        className="card-category"
                      >
                        {product.p_title}
                      </h3>
                    </Col>

                    <Col className="mr-auto" md="6">
                      <div
                        className="iframe-container"
                        style={{
                          position: "relative",
                          paddingBottom: "56.25%",
                          marginTop: { xs: "0", md: "80px" },
                          height: "0",
                          overflow: "hidden",
                        }}
                      >
                        <iframe
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            border: "none",
                          }}
                          src={product.p_video_url}
                          title={product.p_title}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </Col>
                    <Col className="mr-auto" md="5">
                      <Card className="card-plain" style={{ border: "none" }}>
                        <CardBody style={{ paddingTop: "0px" }}>
                          <div className="list-wrapper">
                            {/* Desktop-only title */}
                            <h3
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                textTransform: "uppercase",
                                marginTop: "0px",
                                fontSize: "1.5em",
                                marginBottom: "30px",
                                textAlign: "left",
                                display: "none", // Hide by default
                                "@media (min-width: 768px)": {
                                  display: "block", // Show on desktop
                                },
                              }}
                              className="card-category d-none d-md-block"
                            >
                              {product.p_title}
                            </h3>
                            <ol
                              role="list"
                              className="ol"
                              style={{ marginBottom: "30px" }}
                            >
                              {product.p_description &&
                                product.p_description.map(
                                  (desc, desc_index) => (
                                    <li key={desc_index} className="li">
                                      {desc}
                                    </li>
                                  )
                                )}
                            </ol>
                          </div>
                          <div
                            style={{
                              color: "black !important",
                              textAlign: "left",
                            }}
                          >
                            {product.p_buttons &&
                              product.p_buttons.length > 0 &&
                              product.p_buttons.map((btn, btn_index) => (
                                <Button
                                  key={btn_index}
                                  color="primary"
                                  type="button"
                                  className="learn-more-btn"
                                  //onClick={() => handleButtonClick(btn.url)}
                                  style={{
                                    marginRight: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {btn.title}
                                </Button>
                              ))}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                ))
              )}
            </Container>
          </div>
        </div>

        <div className="testimonials-wrapper" style={{ marginTop: "0px" }}>
          <Testimonials />
        </div>
        {/* We numbers and countries */}
        <div
          className="section section-testimonials"
          style={{ paddingTop: "30px" }}
        >
          <div className="our-clients" style={{ marginTop: "-30px" }}>
            <Container style={{ marginBottom: "50px" }}>
              <ScrollingFlags />
            </Container>
          </div>
        </div>

        {/* Corporate Clients Section */}
        <div
          className="project-4 section"
          style={{ marginBottom: "40px", paddingTop: "10px" }}
        >
          <Container className="text-center">
            <Col className="ml-auto mr-auto" md="8">
              <h2
                style={{
                  fontWeight: "bold",
                  color: "black",
                  marginTop: "20px",
                  fontSize: "clamp(18px, 7.5vw, 45px)",
                  marginBottom: "20px",
                }}
              >
                CORPORATE CLIENTS
              </h2>
            </Col>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                paddingBottom: "50px",
                maxWidth: "1200px",
                margin: "0 auto",
              }}
            >
              <img
                src={corporateclients}
                alt="Our Values"
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                  padding: "0 clamp(10px, 3vw, 30px)",
                  objectFit: "contain",
                }}
              />
            </div>
          </Container>
        </div>

        {/* News & Updates */}
        {media != undefined && media.length > 0 && (
          <Container>
            <h2 className="title" style={{ fontSize: "36px" }}>
              NEWS & UPDATES
            </h2>
            {newsLoading ? (
              <Spinner color="primary" />
            ) : (
              <InstaNewsSection mediaArray={media} />
            )}
          </Container>
        )}

        <FooterBlack />
      </div>
    </>
  );
}

export default LandingPage;
